import React from 'react';

import ItemsProviderSynchronizer from '@common/react/components/Core/AdvancedItemsProvider/ItemsProviderSynchronizer';

import { LocationsProvider } from '@app/components/UI/Location/LocationsProvider';

export const LocationsSynchronizer: React.FC = () => {
	return <LocationsProvider>
		<ItemsProviderSynchronizer
			objectType="LocationRedux"
			getItemsFromInit={(notification) => notification.data.userLocations}
		/>
	</LocationsProvider>;
};
